import React, { useEffect } from 'react'
import { IonRow, IonCol, useIonViewWillEnter, useIonViewDidEnter } from '@ionic/react'
import { useHistory, useLocation } from 'react-router'
import { useSelector } from 'react-redux'

import LoginForm from 'components/basepaws/account/LoginForm'
import GeneralPage from 'components/basepaws/general/GeneralPage/GeneralPage'
import services from 'util/services'
import content from 'util/content'

const AccountLogin = () => {
  const user = useSelector(state => state.userInReducer.user)
  const history = useHistory()
  const location = useLocation()

  const load = async () => {
    const userLocal = await services.user()
    if (userLocal && userLocal.id) {
      if (user && user?.id !== '') {
        history.push('/patients')
      }
    }
  }

  useIonViewDidEnter(() => {
    document.title = 'Vet Portal Sign In - Basepaws'
  })

  useIonViewWillEnter(async () => {
    if (!user?.id) {
      const query = location.hash
      if (query) {
        const data = query.split('/')
        const mail = data[0].substring(1)
        const code = data[1]
        if (mail && code) { await services.post('/auth/confirm', { mail: mail, code: code }) }
      }
      await load()
    } else {
      history.push('/patients')
    }
  })

  useEffect(() => {
    if (user && user.id && user?.id !== '') {
      history.push('/patients')
    }
  }, [user])

  return (
    <GeneralPage
      headerStyle='center'
      title={content.get('LOGIN.HEADER.TITLE_VET_PORTAL')}
      titleClass="Display_4 text_sad_purple ion-margin-top ion-padding-bottom ion-text-center"
      user={user}>
      <IonRow className="ion-justify-content-center">
        <IonCol
          size="11"
          size-lg="4"
          size-md="6"
        >
          <LoginForm/>
        </IonCol>
      </IonRow>
    </GeneralPage>
  )
}

export default AccountLogin
